<template>
  <v-dialog v-model="isActive" persistent scrollable max-width="700">
    <v-card>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
        rounded
        height="6"
      ></v-progress-linear>

      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Respuestas
          </v-card-title>
        </v-img>
      </v-card-title>

      <vuescroll
        :ops="{
          bar: { background: '#bacfcec0', keepShow: true },
        }"
      >
        <v-card-text style="max-height: 350px">
          <v-col cols="12" v-for="(item, index) in data" :key="index">
            <div class="subtitle-1 text--primary">
              {{ item.question_survey.label }}
            </div>

            <p class="text--secondary">{{ item.response }}</p>
            <v-divider></v-divider>
          </v-col>
        </v-card-text>
      </vuescroll>

      <v-divider></v-divider>

      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            class="mr-1"
            :color="hover ? 'error' : 'grey'"
            @click="closedialog('cerrar')"
            >Cerrar</v-btn
          >
        </v-hover>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";

export default {
  components: {
    vuescroll,
  },

  props: ["isActive", "data"],

  data() {
    return {
      isLoading: false,
      payload: {
        name: "",
        description: "",
        survey_id: null,
        email: "",
        type: 2,
      },
      // options: [
      //   {
      //     value: 2,
      //     label: "Supervisor",
      //   },
      //   {
      //     value: 3,
      //     label: "Agente",
      //   },
      // ],
    };
  },

  methods: {
    closedialog(newData) {
      this.$emit("close:dialog", newData);
    },
  },
};
</script>
